const MEASUREMENT_ID = "G-RGQ2HJ2P58";
// The consent engine must be ready before any measurement is allowed.
let consentReader = () => false;
let initialized = false;

const deniedConsent = {
  analytics_storage: "denied",
  ad_storage: "denied",
  ad_user_data: "denied",
  ad_personalization: "denied",
};

export function setAnalyticsConsentReader(reader) {
  consentReader = reader;
}

export function hasAnalyticsConsent() {
  if (typeof window === "undefined") return false;
  try {
    return consentReader() === true;
  } catch {
    return false;
  }
}

function clearAnalyticsCookies() {
  const domains = [
    "",
    ...window.location.hostname
      .split(".")
      .map((_, i, parts) => parts.slice(i).join(".")),
  ];
  const paths = [
    "/",
    ...window.location.pathname
      .split("/")
      .filter(Boolean)
      .map((_, i, parts) => "/" + parts.slice(0, i + 1).join("/")),
  ];
  document.cookie.split(";").forEach((cookie) => {
    const name = cookie.trim().split("=")[0];
    if (!/^_ga(?:_|$)|^_gid$|^_gat(?:_|$)/.test(name)) return;
    domains.forEach((domain) =>
      paths.forEach((path) => {
        document.cookie = `${name}=; Max-Age=0; path=${path}${domain ? `; domain=${domain}` : ""}`;
      }),
    );
  });
}

export function pauseAnalytics() {
  window[`ga-disable-${MEASUREMENT_ID}`] = true;
}

export function stopAnalytics() {
  pauseAnalytics();
  if (initialized) window.gtag("consent", "update", deniedConsent);
  clearAnalyticsCookies();
}

export function startAnalytics() {
  if (!hasAnalyticsConsent()) {
    stopAnalytics();
    return false;
  }
  if (initialized) return false;
  initialized = true;
  window[`ga-disable-${MEASUREMENT_ID}`] = false;
  window.dataLayer = window.dataLayer || [];
  window.gtag = function () {
    window.dataLayer.push(arguments);
  };
  // Basic Consent Mode: queue consent only after the banner validates a grant,
  // before loading the tag or configuring any measurement.
  window.gtag("consent", "default", deniedConsent);
  window.gtag("consent", "update", {
    ...deniedConsent,
    analytics_storage: "granted",
  });
  window.gtag("js", new Date());
  window.gtag("config", MEASUREMENT_ID, {
    send_page_view: false,
    cookie_domain: window.location.hostname,
    cookie_expires: 60 * 60 * 24 * 180,
    cookie_update: false,
    allow_google_signals: false,
    allow_ad_personalization_signals: false,
  });
  const script = document.createElement("script");
  script.id = "gtag-script";
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtag/js?id=${MEASUREMENT_ID}`;
  document.head.appendChild(script);
  return true;
}

export function trackPageView() {
  if (!hasAnalyticsConsent() || typeof window.gtag !== "function") return;
  if (/^\/(?:preview|login|pitlane)(?:\/|$)/.test(window.location.pathname))
    return;
  window.gtag("event", "page_view", {
    page_path: window.location.pathname,
    page_location: window.location.origin + window.location.pathname,
  });
}
